import Navbar from "../components/Navbar";
import React, { ReactNode, useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Chat from "./Chat";
import Login from "./Login";
import Register from "./Register";
import ChangeDisplayName from "./ChangeDisplayName";
import ActiveInterviews from "./ActiveInterviews";
import FeedbackPage from "./Feedback";
import AppAnalytics from "./AppAnalytics";
import PushNotifications from "./PushNotifications";
import { isTokenExpiredOrInvalid } from "../utilities/TokenUtil";
import { refreshToken } from "../utilities/FetchUtil";
import { Flex } from "@mantine/core";
import ChangePassword from "./ChangePassword";
import "@mantine/dropzone/styles.css";
import RemoteConfigs from "./RemoteConfigs";
import ManagePrompts from "./ManagePrompts";
import ManagePredefinedMessages from "./ManagePredefinedMessages";

interface ProtectedRouteProps {
  children: ReactNode;
}

const MainContent = () => {
  const location = useLocation();
  const { pathname } = location;

  const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      if (isTokenExpiredOrInvalid()) {
        refreshToken().catch(() => {
          if (isTokenExpiredOrInvalid()) {
            navigate("/login");
          }
        });
      }
    }, [navigate, location.pathname]);
    return <>{children}</>;
  };

  const RouteList = () => {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navigate to="/active" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-prompts"
          element={
            <ProtectedRoute>
              <ManagePrompts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/remote-configs"
          element={
            <ProtectedRoute>
              <RemoteConfigs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route
          path="/register"
          element={
            <ProtectedRoute>
              <Register />
            </ProtectedRoute>
          }
        />
        <Route
          path="/predefined-messages"
          element={
            <ProtectedRoute>
              <ManagePredefinedMessages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/display-name"
          element={
            <ProtectedRoute>
              <ChangeDisplayName />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/active"
          element={
            <ProtectedRoute>
              <ActiveInterviews submittedInterviews={false} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/submitted"
          element={
            <ProtectedRoute>
              <ActiveInterviews submittedInterviews={true} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/feedback"
          element={
            <ProtectedRoute>
              <FeedbackPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <AppAnalytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <PushNotifications />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  };

  return (
    <Flex justify="center" w="100%">
      {pathname === "/feedback" ? (
        <RouteList />
      ) : (
        <Navbar>
          <div className="app-container">
            <RouteList />
          </div>
        </Navbar>
      )}
    </Flex>
  );
};

export default MainContent;
